module.exports = [{"key":"5.00","text":"Lovpålagt"},{"key":"4.95","text":"NTNU styrevedtak"},{"key":"4.90","text":"IT styrevedtak"},{"key":"4.85","text":"Fastrack vedtak"},{"key":"4.8","text":"Linjeledervedtak"},{"key":"0","text":"Ikke relevant"}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/required.json
// module id = 1113
// module chunks = 0